import router from '@/router';
import store from '@/store/store';
import { classifyHttpError } from '@/shared/http/httpErrorPolicy';

/**
 * @param {import('axios').AxiosError} error
 * @param {import('@/shared/http/httpErrorPolicy').HttpErrorClassification} classification
 */
function applyHttpErrorPolicy(error, classification) {
    const config = error?.config ?? {};
    const silent = classification.scope === 'silent';
    const currentRoute = router.currentRoute?.value;
    const currentPath = currentRoute?.fullPath;

    if (classification.action === 'logout') {
        if (!silent) {
            store.dispatch('clearHttpFeedback');
            store.dispatch('logout', {
                reason: 'session-expired',
                redirect: currentPath,
            });
        }
        return;
    }

    if (classification.action === 'show-feedback') {
        store.dispatch('showHttpFeedback', {
            variant: classification.variant,
            status: classification.status,
            description: classification.messages[0] || '',
            messages: classification.messages,
            source: config.url || currentRoute?.fullPath || null,
        });
    }
}

/**
 * @param {import('axios').AxiosError} error
 * @returns {import('@/shared/http/httpErrorPolicy').HttpErrorClassification}
 */
export function handleHttpError(error) {
    const classification = classifyHttpError(error);
    applyHttpErrorPolicy(error, classification);
    return classification;
}

export { extrairMensagensErro } from '@/shared/http/extrairMensagensErro';

export function errorHandler(error) {
    const classification = handleHttpError(error);
    return classification.messages;
}
